import React, { useEffect, useState } from "react";
import { Modal, List, Row, Col, Typography, Card, Divider } from "antd";
import dayjs from "dayjs";
import { getUserDetailsById } from "../../api/UserAPI"; // adjust path
import AuthService from "../../session/AuthService";

const { Text, Paragraph, Title } = Typography;

export default function AuditTrailModal({ visible, onClose, user }) {
  const [walletDetails, setWalletDetails] = useState(null);
  const [transactionDetails, setTransactionDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible && user) {
      fetchUserDetails(user.id);
    }
  }, [visible, user]);

  const fetchUserDetails = async (userId) => {
    setLoading(true);
    try {
      const form = { id: userId };
      const res = await getUserDetailsById(form);

      // Access the nested data object from response
      const data = res.data.data;

      setWalletDetails(data.walletDetails || null);
      setTransactionDetails(data.transactionDetails || []);
    } catch (err) {
      setWalletDetails(null);
      setTransactionDetails([]);
    } finally {
      setLoading(false);
    }
  };

  const renderTransactionItem = (item) => {
    const currentUserMobile = AuthService.getMobileNo();
    const isCredit = item.toMobileNo === currentUserMobile;

    return (
      <List.Item>
        <Row style={{ width: "100%" }} justify="space-between" align="middle">
          <Col>
            <Text strong>
              {item.transactionType === "B" ? "Bonus" : "Transfer"}
            </Text>
            <br />
            <Text type="secondary" style={{ fontSize: 12 }}>
              {isCredit
                ? item.fromMobileNo
                  ? `Sent from ${item.fromMobileNo}`
                  : "Bonus"
                : `Sent to ${item.toMobileNo}`}
            </Text>
          </Col>
          <Col style={{ textAlign: "right" }}>
            <Text
              style={{
                color: isCredit ? "#10b981" : "#ef4444",
                fontWeight: 600,
              }}
            >
              {isCredit ? "+" : "-"} ₹
              {parseFloat(item.transactionAmount).toFixed(2)}
            </Text>
            <br />
            <Text type="secondary" style={{ fontSize: 12 }}>
              {dayjs(item.createdDate).format("DD MMM YYYY hh:mm")}
            </Text>
          </Col>
        </Row>
      </List.Item>
    );
  };

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      title={`Audit Trail - ${user?.name || ""}`}
      footer={null}
      width={700}
      bodyStyle={{ maxHeight: "60vh", overflowY: "auto" }}
      confirmLoading={loading}
    >
      {walletDetails && (
        <>
          <Card style={{ marginBottom: 16 }}>
            <Title level={5}>Wallet Details</Title>
            <Row gutter={16}>
              <Col span={12}>
                <Text strong>Total Balance:</Text> ₹
                {walletDetails.totalBalance.toFixed(2)}
              </Col>
              <Col span={12}>
                <Text strong>Status:</Text>{" "}
                {walletDetails.walletActive ? (
                  <Text type="success">Active</Text>
                ) : (
                  <Text type="danger">Inactive</Text>
                )}
              </Col>
            </Row>
          </Card>
          <Divider />
        </>
      )}

      {transactionDetails.length > 0 ? (
        <List
          dataSource={transactionDetails}
          renderItem={renderTransactionItem}
          loading={loading}
          split
          bordered
          pagination={{ pageSize: 10 }}
        />
      ) : (
        <Card style={{ textAlign: "center" }}>
          <Text type="secondary">No transactions yet</Text>
          <Paragraph>Your transactions will appear here</Paragraph>
        </Card>
      )}
    </Modal>
  );
}
